<template>
  <v-card class="pe-8 pl-8 pb-8">
    <div class="card-header">
      <div />

      <div class="text-center">
        <h3 class="header-title">
          Registros de abastecimentos
        </h3>
      </div>
      <v-btn
        icon
        class="close-button"
        @click="closeModal"
      >
        <v-icon size="30">
          {{ icons.mdiClose }}
        </v-icon>
      </v-btn>
    </div>

    <div
      v-for="(item, index) in supplyHistoryList.data"
      :key="item.id"
      class="supply-card"
    >
      <!-- HEADER (CLICÁVEL) -->
      <div
        class="header"
        @click="toggle(index)"
      >
        <div style="display: flex; align-items: center;">
          <v-icon
            color="#E7E3FC"
            style="margin-right: 10px;"
          >
            {{ icons.mdiGasStationOutline }}
          </v-icon>

          <span>#{{ index + 1 }} Detalhes do abastecimento</span>
        </div>

        <v-icon
          :class="{'rotated': expandedIndex === index}"
        >
          {{ icons.mdiChevronDown }}
        </v-icon>
      </div>

      <!-- CONTEÚDO EXPANSÍVEL -->
      <transition name="expand">
        <div
          v-show="expandedIndex === index"
          class="content"
        >
          <div class="container-items">
            <div class="container-item">
              <div style="display: flex; gap: 10px">
                <v-icon color="#E7E3FC">
                  {{ icons.mdiCarHatchback }}
                </v-icon>

                <span>Modelo</span>
              </div>

              <span
                class="mt-3"
                style="font-size: 15px;"
              >{{ item.vehicle.model ? item.vehicle.model : 'N/A' }}</span>
            </div>

            <div class="container-item">
              <div style="display: flex; gap: 10px">
                <v-icon color="#E7E3FC">
                  {{ icons.mdiTools }}
                </v-icon>

                <span>Montadora</span>
              </div>

              <span
                class="mt-3"
                style="font-size: 15px;"
              >{{ item.vehicle.manufacturer ? item.vehicle.manufacturer.name : 'N/A' }}</span>
            </div>

            <div class="container-item">
              <div style="display: flex; gap: 10px">
                <v-icon color="#E7E3FC">
                  {{ icons.mdiCalendarToday }}
                </v-icon>

                <span>Ano</span>
              </div>

              <span
                class="mt-3"
                style="font-size: 15px;"
              >{{ item.vehicle.model_year ? item.vehicle.model_year : 'N/A' }}</span>
            </div>

            <div class="container-item">
              <div style="display: flex; gap: 10px">
                <v-icon color="#E7E3FC">
                  {{ icons.mdiRoadVariant }}
                </v-icon>

                <span>Km atual</span>
              </div>

              <span
                class="mt-3"
                style="font-size: 15px;"
              >{{ item.vehicle.actual_km ? item.vehicle.actual_km : 'N/A' }}</span>
            </div>
          </div>

          <div class="container-form">
            <div>
              <span>Dados do abastecimento</span>

              <v-icon
                size="25"
                class="ms-2"
                color="#E7E3FC"
              >
                {{ icons.mdiGasStationOutline }}
              </v-icon>
            </div>

            <v-text-field
              v-model="item.driver.name"
              class="mt-8"
              label="Motorista"
              outlined
              disabled
              dense
            />

            <div
              class="d-flex"
              style="gap: 16px;"
            >
              <v-text-field
                v-model="item.invoice_number"
                outlined
                disabled
                dense
                label="N° da nota"
                style="width: 50%"
              />

              <v-switch
                :value="!item.invoice_number"
                dense
                disabled
                inset
                style="margin-top: 0px; padding-top: 9px; width: 50%;"
                label="Nota sem numeração"
              />
            </div>

            <v-text-field
              v-model="item.fuel_type.name"
              disabled
              outlined
              dense
              label="Combustível"
            />

            <div style="display: flex; gap: 16px;">
              <v-text-field
                :value="dateFormat(item.created_at)"
                disabled
                outlined
                dense
                label="Data"
              />

              <v-text-field
                :value="formatCurrency(item.supply_price_per_liter)"
                disabled
                outlined
                dense
                label="Preço/L"
              />
            </div>

            <div style="display: flex; gap: 16px;">
              <v-text-field
                :value="item.supply_amount_per_liter"
                disabled
                outlined
                dense
                label="Abastecimento/L"
              />

              <v-text-field
                :value="item.final_km"
                disabled
                outlined
                dense
                label="Km final"
              />
            </div>
          </div>

          <div class="container-infos">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <span>Km percorrido</span>

              <span>{{ item.final_km - item.previous_km }}</span>
            </div>

            <div style="display: flex; flex-direction: column; align-items: center;">
              <span>Km/L</span>

              <span>{{ kmPerLiter(Number(item.supply_amount_per_liter), Number(item.final_km - item.previous_km)) }}</span>
            </div>

            <div style="display: flex; flex-direction: column; align-items: center;">
              <span>Valor pago</span>

              <span>{{ formattedAmountPaid(item.amount_paid) }}</span>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </v-card>
</template>
<script>
import formatters from '@/plugins/formattersMixin1'
import messages from '@/plugins/showMessageMixin'
import utilsMixin from '@/plugins/utilsMixin'
import {
  mdiCalendarToday,
  mdiCarHatchback,
  mdiChevronDown,
  mdiClose,
  mdiGasStationOutline,
  mdiRoadVariant,
  mdiTools,
} from '@mdi/js'

export default {
  name: 'SupplyHistory',

  components: {
  },
  mixins: [utilsMixin, messages, formatters],
  props: {
    solicData: {
      type: Object,
      default: () => ({}),
    },
    usersList: {
      type: Array,
      default: () => [],
    },
    vehiclesList: {
      type: Array,
      default: () => [],
    },
    driversList: {
      type: Array,
      default: () => [],
    },
    supplyHistoryList: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      icons: {
        mdiClose,
        mdiCarHatchback,
        mdiTools,
        mdiCalendarToday,
        mdiRoadVariant,
        mdiGasStationOutline,
        mdiChevronDown,
      },
      driver: '',
      invoiceNumber: '',
      withoutInvoiceNumber: false,
      expandedIndex: null,
      hasNotInvoice: false,
    }
  },

  methods: {
    closeModal() {
      this.$emit('close')
    },

    toggle(index) {
      this.expandedIndex = this.expandedIndex === index ? null : index
    },

    kmPerLiter(amountLiters, kmTraveled) {
      const litros = parseFloat(amountLiters) || 0
      if (litros === 0) return 0

      return (kmTraveled / litros).toFixed(2)
    },

    amountPaid(liters, pricePerLiter) {
      const litros = parseFloat(liters) || 0
      const precoPorLitro = parseFloat(
        (pricePerLiter || '').replace(/[^\d,]/g, '').replace(',', '.'),
      ) || 0

      return this.formattedAmountPaid((litros * precoPorLitro).toFixed(2))
    },

    formattedAmountPaid(amountPaid) {
      if (amountPaid === null || amountPaid === undefined || amountPaid === '') {
        return 'R$0,00'
      }

      const amount = amountPaid / 100

      return `R$${amount.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    },
  },
}
</script>
<style scoped>
.card-header {
  width: 100%;
  padding-top: 30px;
  margin-bottom: 16px;

  display: flex;
  align-items: center;
  justify-content: space-between;
}

.supply-card {
  background: #2e2748;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
}

.header {
  padding: 14px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #28243D;
  color: #fff;
  font-weight: 500;
}

.content {
  padding: 16px;
  background: #28243D;
  color: #e7e3fc;
}

.expand-enter-active,
.expand-leave-active {
  transition: all 0.25s ease;
}

.expand-enter,
.expand-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

.container-items{
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.container-item{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.container-form{
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 10px;
  background: #3B355A;
  margin-top: 16px;
}

.container-infos{
  display: flex;
  justify-content: space-between;
  margin-top: 16px;

  background: #3B355A;
  padding: 16px 40px;
  border-radius: 10px;

}
</style>
